import { MessageCircle } from "lucide-react";

interface WhatsAppButtonProps {
  onClick?: () => void;
}

const WhatsAppButton = ({ onClick }: WhatsAppButtonProps) => {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#128C7E] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center hover:scale-110 cursor-pointer"
      aria-label="Fale conosco pelo WhatsApp"
    >
      <MessageCircle className="w-7 h-7 fill-current" />
    </button>
  );
};

export default WhatsAppButton;
